/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
// import React from 'react';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';
import AssignmentIcon from '@mui/icons-material/Assignment';
import BugIcon from '@mui/icons-material/BugReport';
import DirectionsIcon from '@mui/icons-material/Directions';
import SelectAllIcon from '@mui/icons-material/SelectAll';
import MapIcon from '@mui/icons-material/Map';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import SpeakerPhoneIcon from '@mui/icons-material/SpeakerPhone';
import { MatchLogic } from '../../components/ProtectedRoute/ProtectedRoute';
import { Role } from '../../constants/roles';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { SvgIconTypeMap } from '@mui/material';
import { userHasRoles } from '../../services/role-service';
import { AirplaneTicket, ChatRounded, FoodBank, PhoneAndroid, SmartToyOutlined, Storefront } from '@mui/icons-material';

export interface MenuItem {
  title: string;
  pages: MenuItemPage[];
}
interface MenuItemPage {
  title: string;
  href: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string; };
  rules: {
    requiredRoles: Role[];
    matchLogic: MatchLogic
  }
}

const allMenuItems: MenuItem[] = [
  {
    title: 'Navigation',
    pages: [
      {
        title: 'Aerospace',
        href: '/aerospace',
        icon: AirplanemodeActiveIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Commercial_Admin,
            Role.Portal_Dev_Admin,
            Role.Portal_Business_Viewer
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Aerospace 3D',
        href: '/aerospace3D',
        icon: AirplanemodeActiveIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin
          ],
          matchLogic: MatchLogic.OR
        },
      }
    ]
  },
  {
    title: 'Admin',
    pages: [
      {
        title: 'Route Planner',
        href: '/admin/route-planner',
        icon: MapIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Geofences',
        href: '/admin/geofences',
        icon: SelectAllIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      }
    ]
  },
  {
    title: 'Operations',
    pages: [
      {
        title: 'Order Hub',
        href: '/restaurant/orderhubSSE',
        icon: DeveloperBoardIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Commercial_Admin,
            Role.Portal_Commercial_CS,
            Role.Portal_Commercial_Marketing,
            Role.Portal_Business_Viewer,
            Role.Portal_Dev_Admin,
            Role.Portal_Ops_SIM
          ],
          matchLogic: MatchLogic.OR
        },
      },     
      {
        title: 'Issue Hub',
        href: '/bom/issues',
        icon: BugIcon,
        rules: {
          requiredRoles: [
              Role.Portal_Dev_Admin,
              Role.ROLE_DEPOT_MFG_ADMIN,
              Role.ROLE_DEPOT_MFG_USER,
              Role.ROLE_DEPOT_ENGINEERING_ADMIN,
              Role.ROLE_DEPOT_ENGINEERING_USER,
              Role.ROLE_DEPOT_OPS_ADMIN,
              Role.ROLE_DEPOT_OPS_USER,
              Role.ROLE_DEPOT_ADMIN,
              Role.Portal_Ops_MC,
              Role.Portal_Business_Viewer,
              Role.Portal_Ops_Admin,
              Role.Portal_Ops_Support,
              Role.Portal_Ops_GroundTeam
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Mobile Drop Analyzer',
        href: '/mobile-drop-analyzer',
        icon: PhoneAndroid,
        rules: {
          requiredRoles: [
            Role.Portal_Commercial_CS,
            Role.Portal_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Delivery Spot Management',
        href: '/drop-point-management',
        icon: MapIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Commercial_CS,
            Role.Portal_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Weigher App',
        href: '/restaurant/ops',
        icon: DeveloperBoardIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Ops_Support,
            Role.Portal_Ops_GroundTeam,
            Role.Portal_Commercial_Admin,
            Role.Portal_Commercial_CS,
            Role.Portal_Commercial_Marketing,
            Role.Portal_Business_Viewer,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Loader Screen',
        href: '/restaurant/ops-v3',
        icon: DeveloperBoardIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Ops_Support,
            Role.Portal_Ops_GroundTeam,
            Role.Portal_Commercial_Admin,
            Role.Portal_Commercial_CS,
            Role.Portal_Commercial_Marketing,
            Role.Portal_Business_Viewer,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Collector UI',
        href: '/restaurant/collector-ops',
        icon: DeveloperBoardIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Ops_Support,
            Role.Portal_Ops_GroundTeam,
            Role.Portal_Commercial_Admin,
            Role.Portal_Commercial_CS,
            Role.Portal_Commercial_Marketing,
            Role.Portal_Business_Viewer,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      },
    ]
  },
  {
    title: 'Commercial',
    pages: [
      {
        title: 'Commercial',
        href: '/commercial',
        icon: SpeakerPhoneIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Commercial_Admin,
            Role.Portal_Commercial_CS,
            Role.Portal_Commercial_Marketing,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Merchant Devices',
        href: '/merchant-devices',
        icon: PhoneAndroid,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Commercial_Admin,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Store Creation',
        href: '/store-creation',
        icon: Storefront,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Commercial_Admin,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      }
    ]
  },
  {
    title: 'BOM',
    pages: [
      {
        title: 'Asset Status',
        href: '/bom/overview',
        icon: AssignmentIcon,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Dev_Admin,
            Role.ROLE_DEPOT_ADMIN,
            Role.ROLE_DEPOT_MFG_ADMIN,
            Role.ROLE_DEPOT_MFG_USER,
            Role.ROLE_DEPOT_OPS_ADMIN,
            Role.ROLE_DEPOT_OPS_USER,
            Role.ROLE_DEPOT_ENGINEERING_ADMIN,
            Role.ROLE_DEPOT_ENGINEERING_USER,
          ],
          matchLogic: MatchLogic.OR
        },
      }
    ]
  },
  {
    title: 'Testing',
    pages: [
      {
        title: 'Flight test plans',
        href: '/flight-test-plan',
        icon: SmartToyOutlined,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Dev_Admin,
            Role.Portal_Ops_SIM
          ],
          matchLogic: MatchLogic.OR
        }
      },
      {
        title: 'Flight cards',
        href: '/flight-cards',
        icon: AirplaneTicket,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Dev_Admin,
            Role.Portal_Flight_Testing,
            Role.Portal_Pilot
          ],
          matchLogic: MatchLogic.OR
        }
      },
    ],
  },
  {
    title: 'Development',
    pages: [
      {
        title: 'Test Order',
        href: '/test-orders',
        icon: FoodBank,
        rules: {
          requiredRoles: [
            Role.Portal_Dev_Admin,
            Role.Portal_Ops_Admin,
            Role.Portal_Ops_MC,
            Role.Portal_Admin,
            Role.Portal_Commercial_Admin
          ],
          matchLogic: MatchLogic.OR
        },
      },
      {
        title: 'Cell Information',
        href: '/cell-information',
        icon: FoodBank,
        rules: {
          requiredRoles: [
            Role.Portal_Admin,
            Role.Portal_Dev_Admin,
          ],
          matchLogic: MatchLogic.OR
        },
      }
    ]
  }
];

export async function getNavigationConfig(): Promise<MenuItem[]> {
  const allowedMenuItems = [];

  for (let i = 0; i < allMenuItems.length; i++) {
    const allowedPages = [];

    for (let j = 0; j < allMenuItems[i].pages.length; j++) {
      const isAllowed = await userHasRoles(allMenuItems[i].pages[j].rules.requiredRoles, allMenuItems[i].pages[j].rules.matchLogic);
      if (isAllowed) {
        allowedPages.push(allMenuItems[i].pages[j])
      }
    }
    allowedMenuItems.push(Object.assign({}, allMenuItems[i], { pages: allowedPages }));
  }

  return allowedMenuItems;
}
